import type { CampaignsReportResponse } from "@gioia365/contracts";
import { CampaignsTable } from "./CampaignsTable";
import { SalesByCampaign } from "./SalesByCampaign";

// La scheda «Campagne» del Report (piano M7, Task 5; mock-up `renderCampagne`; D8): «Le campagne» (`CampaignsTable.tsx`) e «Vendite
// per campagne» (`SalesByCampaign.tsx`), dalla stessa lettura di `GET /api/reports/campaigns`. Periodo, «Di chi» e stati (caricamento,
// vuoto, errore, senza accesso) sono quelli della pagina (`ReportsPage.tsx`), come per «Commerciali».

type Props = {
  report: CampaignsReportResponse;
  /** Il periodo scritto, per le didascalie. */
  range: string;
  /** Di chi sono i numeri, la frase sotto «Le campagne». */
  whose: string;
  /** Il fuso dell'azienda, per i giorni delle vendite. */
  timeZone: string;
};

export function CampaignsTab({ report, range, whose, timeZone }: Props) {
  return (
    <>
      <CampaignsTable report={report} range={range} whose={whose} />
      <SalesByCampaign report={report} range={range} timeZone={timeZone} />
    </>
  );
}
